<template>
  <ul class="wrapp-stores-wrapp-list">
    <li v-for="store in stores" :key="store.code" class="wrapp-stores-wrapp-list-item">
      <store-tile :store="store" :isCheckoutMode="isCheckoutMode" />
    </li>
    <li v-show="!stores.length">
      <div class="no-stores text-center">
        {{ inputText.length ? $t('storelocator.no-store-found') : $t('storelocator.type-to-search-store') }}
      </div>
    </li>
  </ul>
</template>

<script>

import StoreTile from 'theme/components/Search/Tiles/StoreTile'

export default {
  name: 'StoresList',
  props: {
    stores: {
      type: Array,
      required: true
    },
    inputText: {
      type: String,
      default: () => ''
    },
    isCheckoutMode: {
      type: Boolean,
      default: false
    }
  },
  components: {
    StoreTile
  }
}
</script>
